import { createContext, useContext } from "react";

const WorkshopSearchContext = createContext("");

export const WorkshopSearchProvider = WorkshopSearchContext.Provider;

export function useWorkshopSearch() {
  return useContext(WorkshopSearchContext);
}
